module.exports = __webpack_public_path__ + "static/mawsons-will-5ec37b85147158838f08ffe8ef08aa7e.jpg";